import Employee from "./components/Employee.vue";
import EmployeeLogin from "./components/EmployeeLogin.vue";
import WorkDays from "./components/Workdays.vue";
import WorkDay from "./components/Workday.vue";
import EditWorkRegistration from "./components/EditWorkRegistration.vue";
import CreateWorkRegistration from "./components/CreateWorkRegistration.vue";
import Notifications from "./components/Notifications.vue";
import ResetPassword from "./components/ResetPassword.vue";
import AddTravelTimeComponent from "./components/AddTravelTime.vue";
import AddPauseTimeComponent from "./components/AddPause.vue";
import OtherSelectionComponent from "./components/OtherSelection.vue";
import AddUnforeseenComponent from "./components/AddUnforeseen.vue";
import ProjectOverviewComponent from "./components/ProjectOverview.vue";
import AddProjectActivityComponent from "./components/AddProjectActivity.vue";
import AddOtherActivityComponent from "./components/AddOtherActivities.vue"

import AccountService from "./services/AccountService";

function isEmployeeActive(employeeId){
  return new AccountService().isEmployeeActive(employeeId);
}

function authorizedGuard(to, from, next) {
  let isAuthenticated = false;

  if (!localStorage.getItem("authtoken")){
    next("/employee-login");
  }
  else{
    const jwtPayload = parseJwt(localStorage.getItem("authtoken"));
    isEmployeeActive(jwtPayload.nameid).then((res) => {
      console.log("res", res);
      isAuthenticated = res.data;
      console.log("jwtPayload", jwtPayload);
      console.log("isAuthenticated", isAuthenticated);
      if (isAuthenticated) {
        next(); // allow to enter route
      } else {
        next("/employee-login");
      }
    })
    
    // if (jwtPayload.exp < Date.now()/1000) {
    //   isAuthenticated = false;
    //   localStorage.clear();
    // }
    // else isAuthenticated = true;
  } 
}

function parseJwt (token) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(Buffer.from(base64, "base64").toString("ascii").split("").map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
}

export const routes = [
  { path: "", name: "employee-login", component: EmployeeLogin },
  { path: "/employee", name: "employee", component: Employee },
  { path: "/employee-login", name: "employee-login", component: EmployeeLogin },
  { path: "/reset-password", name: "reset-password", component: ResetPassword },
  {
    path: "/work-days",
    name: "work-days",
    component: WorkDays,
    beforeEnter: authorizedGuard,
  },
  {
    path: "/work-day",
    name: "work-day",
    component: WorkDay,
    beforeEnter: authorizedGuard,
  },
  {
    path: "/edit-work-registration",
    name: "edit-work-registration",
    component: EditWorkRegistration,
    beforeEnter: authorizedGuard,
  },
  {
    path: "/create-work-registration",
    name: "create-work-registration",
    component: CreateWorkRegistration,
    beforeEnter: authorizedGuard,
  },
  {
    path: "/notifications",
    name: "notifications",
    component: Notifications,
    beforeEnter: authorizedGuard,
  },
  {
    path: "/add-travel-time",
    name: "add-travel-time",
    component: AddTravelTimeComponent,
    beforeEnter: authorizedGuard,
  },
  {
    path: "/add-pause",
    name: "add-pause",
    component: AddPauseTimeComponent,
    beforeEnter: authorizedGuard,
  },
  {
    path: "/other-selection",
    name: "other-selection",
    component: OtherSelectionComponent,
    beforeEnter: authorizedGuard,
  },
  {
    path: "/add-unforeseen",
    name: "add-unforeseen",
    component: AddUnforeseenComponent,
    beforeEnter: authorizedGuard,
  },
  {
    path: "/project-overview",
    name: "project-overview",
    component: ProjectOverviewComponent,
    beforeEnter: authorizedGuard,
  },
  {
    path: "/add-project-activity",
    name: "add-project-activity",
    component: AddProjectActivityComponent,
    beforeEnter: authorizedGuard,
  },
  {
    path: "/add-other-activities",
    name: "add-other-activities",
    component: AddOtherActivityComponent,
    beforeEnter: authorizedGuard,
  },
];
